import { createElement } from '@max/max';
import LImage from '@max/leez-image';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
const iconMap = {
    empty: 'https://p0.meituan.net/travelcube/70ebeaaad24595c07aa27e01375d104512206.png',
    error: 'https://p0.meituan.net/travelcube/da491ae052861c919a717b8752d6834811672.png'
};
export default function ActivityInvalid(props) {
    return <View style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '24rpx',
        ...(props.style || {})
    }}>
      <LImage style={{
        width: '285rpx',
        height: '285rpx',
        ...(props.iconStyle || {})
    }} source={{
        uri: props.icon || iconMap[props.type || 'empty']
    }}/>
      <Text x-if={props.text} className="activity-end-desc" style={{
        color: props.color,
        ...(props.textStyle || {})
    }}>
        {props.text}
      </Text>
    </View>;
}
